import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getConfiguracoesPublico } from '../services/api';

const API_URL = process.env.REACT_APP_API_URL || '';
const WHATSAPP = '5511913302273';

export default function Home() {
  const [config, setConfig] = useState({ nome_lanchonete: 'Empório Paco', slogan: 'Os melhores lanches do parque! 🔥', logo_url: null, banner_url: null });
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getConfiguracoesPublico().then(r => {
      setConfig(c => ({ ...c, ...r.data }));
    }).catch(() => {});
  }, []);

  const compartilhar = async () => {
    const url = 'https://emporiopaco.online';
    const texto = 'Peça pelo app do Empório Paco - Lanchonete! 🍔';
    if (navigator.share) {
      try { await navigator.share({ title: 'Empório Paco', text: texto, url }); } catch (e) {}
    } else {
      navigator.clipboard.writeText(url);
      alert('Link copiado!');
    }
  };

  const abrirWhatsapp = () => {
    window.open(`https://wa.me/${WHATSAPP}?text=Olá! Gostaria de fazer um pedido.`, '_blank');
  };

  const botoes = [
    { icon: '🍔', label: 'FAÇA SEU PEDIDO', action: () => navigate('/cardapio') },
    { icon: '🏆', label: 'PROGRAMA DE FIDELIDADE', action: () => navigate('/fidelidade') },
    { icon: '📋', label: 'MEUS PEDIDOS', action: () => navigate('/meus-pedidos') },
    { icon: '⭐', label: 'AVALIE NO GOOGLE', action: () => window.open('#', '_blank') },
    { icon: '💬', label: 'FALE CONOSCO', action: abrirWhatsapp },
    { icon: '📤', label: 'COMPARTILHE', action: compartilhar },
    { icon: '📷', label: 'SIGA NO INSTAGRAM  @emporiopaco', action: () => window.open('https://instagram.com/emporiopaco', '_blank'), fullWidth: true },
  ];

  return (
    <div style={{ padding: '16px 16px 20px' }}>
      {/* HERO */}
      <div style={{
        background: 'linear-gradient(135deg,#1a0000,#0a0a0a)',
        border: '1px solid #3a0000', borderRadius: 16, padding: 24,
        marginBottom: 20, position: 'relative', overflow: 'hidden', textAlign: 'center'
      }}>
        <div style={{ position: 'absolute', right: -20, top: -20, fontSize: 120, opacity: .06 }}>🍔</div>
        <div style={{ position: 'absolute', left: -20, bottom: -20, fontSize: 100, opacity: .05 }}>🔥</div>

        {config.logo_url && (
          <img src={`${API_URL}${config.logo_url}`} alt="Logo"
            style={{ width: 110, height: 110, objectFit: 'contain', marginBottom: 10 }} />
        )}
        <h1 style={{
          fontFamily: "'Bebas Neue', sans-serif", fontSize: 32,
          background: 'linear-gradient(90deg,var(--red),var(--orange))',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          lineHeight: 1, marginBottom: 6, letterSpacing: 1
        }}>{config.nome_lanchonete || 'Empório Paco'}</h1>
        <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: user ? 14 : 0 }}>
          {config.slogan || 'Os melhores lanches do parque! 🔥'}
        </p>

        {user && (
          <div onClick={() => navigate('/fidelidade')} style={{
            display: 'inline-flex', alignItems: 'center', gap: 10, cursor: 'pointer',
            background: 'rgba(255,107,0,.12)', border: '1px solid rgba(255,107,0,.35)',
            borderRadius: 10, padding: '8px 14px', marginTop: 4
          }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: 'var(--orange)' }}>{user.pontos || 0}</span>
            <span style={{ fontSize: 12, color: 'var(--text2)', textAlign: 'left', lineHeight: 1.3 }}>
              pontos<br /><small>Toque para ver</small>
            </span>
          </div>
        )}
      </div>

      {/* GRID DE BOTÕES */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {botoes.map((b, i) => (
          <button key={i} onClick={b.action} style={{
            gridColumn: b.fullWidth ? '1 / -1' : 'auto',
            background: 'linear-gradient(135deg, #FF6B00, #FF8533)',
            border: 'none', borderRadius: 16, padding: '22px 12px',
            color: '#fff', cursor: 'pointer',
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: 10, minHeight: 130,
            boxShadow: '0 4px 12px rgba(255,107,0,.25)',
            transition: 'transform .15s, box-shadow .15s',
            fontFamily: 'inherit'
          }}
          onTouchStart={e => e.currentTarget.style.transform = 'scale(.96)'}
          onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}
          onMouseDown={e => e.currentTarget.style.transform = 'scale(.96)'}
          onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <span style={{ fontSize: 44, lineHeight: 1 }}>{b.icon}</span>
            <span style={{ fontSize: 12, fontWeight: 800, textAlign: 'center', lineHeight: 1.2, letterSpacing: .3 }}>
              {b.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
